import styled from "styled-components";
import { Button } from "@thenounproject/lingo-core";

export const OverflowButton = styled(Button).attrs({
  className: "action-button",
  size: "small",
  buttonStyle: "secondary",
  position: "absolute",
  top: "5px",
  right: "2px",
  zIndex: 10,
})`
  opacity: 0;
  box-shadow: 0 1px 3px 0 rgba(36, 36, 37, 0.12) !important;
  transition: opacity 0.1s ease-in-out !important;
`;
